import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const BlogFilterDrawer = ({ open, onClose, filters, setFilters, onSearch, onClear }) => {
  const { t } = useTranslation();

  const categories = [
    { id: '', label: t('blog.categories.all') },
    { id: 'roommate', label: t('blog.categories.roommate') },
    { id: 'security', label: t('blog.categories.security') },
    { id: 'renting', label: t('blog.categories.renting') },
    { id: 'lifestyle', label: t('blog.categories.lifestyle') },
    { id: 'tips', label: t('blog.categories.tips') }
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: '100%', sm: 400 } }
      }}
    >
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          {t('blog.filters.title')}
        </Typography>

        <Stack spacing={3} sx={{ mt: 3 }}>
          <TextField
            fullWidth
            label={t('blog.search')}
            value={filters.searchText}
            onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
          />

          <FormControl fullWidth>
            <InputLabel>{t('blog.filters.category')}</InputLabel>
            <Select
              value={filters.category}
              label={t('blog.filters.category')}
              onChange={(e) => setFilters({ ...filters, category: e.target.value })}
            >
              {categories.map((category) => (
                <MenuItem key={category.id} value={category.id}>
                  {category.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            type="date"
            label={t('blog.filters.startDate')}
            value={filters.startDate}
            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            fullWidth
            type="date"
            label={t('blog.filters.endDate')}
            value={filters.endDate}
            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
          />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={onSearch}
            >
              {t('blog.filters.search')}
            </Button>
            <Button
              fullWidth
              variant="outlined"
              onClick={onClear}
            >
              {t('blog.filters.clear')}
            </Button>
          </Box>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default BlogFilterDrawer; 